import { css } from 'styled-components';

export const antdModal = css`
  .ant-modal .ant-modal-content {
    border-radius: 6px;

    .ant-modal-header {
      padding: 0;
      border-radius: 10px 10px 0 0;
    }

    .ant-modal-close-x {
      width: 42px;
      height: 42px;
      font-size: 23px;
      line-height: 42px;
    }

    .ant-modal-body {
      padding: 30px;
    }
  }
`;
